<template>
  <div class="form-container">
    <h1 class="mb-4">測定種別情報新規作成</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>

      <div class="mb-3">
        <label for="measureTypeName" class="form-label">測定種別名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="measure_type.measure_type_nm" type="text" placeholder="測定種別名" class="form-control" id="measureTypeName" required>
        <div v-if="errorMessages.measure_type_nm" class="alert alert-danger mt-2">{{ errorMessages.measure_type_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="sortNumber" class="form-label">並び順 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="measure_type.sort_no" type="number" placeholder="並び順" class="form-control" id="sortNumber" required>
        <div v-if="errorMessages.sort_no" class="alert alert-danger mt-2">{{ errorMessages.sort_no[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-primary mx-1">登録</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { createMeasureType } from '@/api/axios';

export default {
  setup() {
    const title = ref('測定種別情報新規作成');

    watchEffect(() => {
      document.title = title.value;
    });

    const measure_type = ref({
      measure_type_nm: '',
      sort_no: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();

    const handleSubmit = async () => {
      try {
        await createMeasureType(measure_type.value);
        store.commit('setFlashMessage', {message: '測定種別情報作成完了！', type: 'success'});
        router.push(`/measure-types`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '測定種別情報作成失敗！', type: 'danger'});
        console.error('作成エラー:', error);
      }
    };

    return {
      title,
      measure_type,
      handleSubmit,
      errorMessages
    };
  }
};
</script>

<style scoped>
.form-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
